import { RMAXLogger } from '@RMAXLogger';
import { NOTIFICATIONS_CONTENT } from '../../content';

export type DriverMessagePayload = {
  sender?: string;
  message?: string;
  [key: string]: unknown;
};

export type MessageFromDriverAlertDeps = {
  currentActiveRoutes?: Array<{ driverId?: string }>;
  openChatDriverId?: string | null;
  playSound: () => void;
  showToast: (rawMessage: string) => void;
  addNotification: (messages: DriverMessagePayload[]) => void;
};

/**
 * Sound / toast / store updates for MessageFromDriver (header-owned; Drivers Grid excluded).
 */
export const handleMessageFromDriverAlert = (
  driverMessageString: string,
  deps: MessageFromDriverAlertDeps
): void => {
  let driverMessage: DriverMessagePayload;
  try {
    driverMessage = JSON.parse(driverMessageString);
  } catch (error) {
    RMAXLogger.error(NOTIFICATIONS_CONTENT.logging.messageFromDriverParseFailed, {
      error,
      payloadPreview:
        typeof driverMessageString === 'string'
          ? driverMessageString.slice(0, 200)
          : driverMessageString,
    });
    return;
  }

  const sender = driverMessage?.sender?.toUpperCase?.();
  if (!sender || !driverMessage?.message?.length) {
    return;
  }

  const matchRoute = deps.currentActiveRoutes?.find(
    (route) => route.driverId?.toUpperCase() === sender
  );
  if (matchRoute) {
    deps.playSound();
  }

  const openChatDriverId = deps.openChatDriverId?.toUpperCase?.();
  if (openChatDriverId === sender) {
    return;
  }

  deps.showToast(driverMessageString);
  deps.addNotification([driverMessage]);
};
